import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Product from './components/Product';
import SolutionsPage from './components/SolutionsPage';
import WhyUs from './components/WhyUs';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageMeta from './components/PageMeta';
import GoodWeEsa from './components/Product/GoodWeEsa';
import AlphaEss from './components/Product/AlphaEss';
import AlphaEssSmileG3S5 from './components/Product/AlphaEssSmileG3S5';
import AlphaEssSmileG3 from './components/Product/AlphaEssSmileG3';
import SofarPage from './components/Product/Sofar';
import Enquiry from './components/Enquiry';
import Commercial from './components/Commercial';
import PromoPopup from './components/PromoPopup';
import Sitemap from './components/Sitemap';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageMeta />
      {
        window.location.pathname === '/enquiry' ? null : (
          <Navbar />
        )
      }
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/residential-solutions" element={<SolutionsPage />} />
        <Route path="/product" element={<Product />} />
        <Route path="/product/goodwe-esa" element={<Product Hero={GoodWeEsa} />} />
        <Route path="/product/sofar" element={<Product Hero={SofarPage} />} />
        <Route path="/product/alpha-ess" element={<Product Hero={AlphaEss} />} />
        <Route path="/product/alpha-ess-smile-g3-s5" element={<Product Hero={AlphaEssSmileG3S5} />} />
        <Route path="/product/alpha-ess-smile-g3" element={<Product Hero={AlphaEssSmileG3} />} />
        <Route path="/why-us" element={<WhyUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/:slug" element={<BlogPost />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/commercial-solutions" element={<Commercial />} />
        <Route path="/sitemap" element={<Sitemap />} />
        {/* Old URLs — the permanent 301 is done in nginx; this covers anything that reaches the app */}
        <Route path="/residential_solutions" element={<Navigate to="/residential-solutions" replace />} />
        <Route path="/commercial_solutions" element={<Navigate to="/commercial-solutions" replace />} />
      </Routes>
      {window.location.pathname !== '/enquiry' && <Footer />}
      {window.location.pathname !== '/enquiry' && <PromoPopup />}
    </Router>
  );
}

export default App;